import { createContext } from 'react';

const EducationContext = createContext();

export default EducationContext;
